import type { ExpertTrialBalanceColumnId } from '../hooks/useExpertTrialBalanceColumns'

export const EXPERT_TRIAL_BALANCE_COLUMN_IDS: ExpertTrialBalanceColumnId[] = [
  'accountNumber',
  'label',
  'debit',
  'credit',
  'balance',
  'balancePrevious',
]

export const EXPERT_TRIAL_BALANCE_DEFAULT_HIDDEN_COLUMN_IDS: ExpertTrialBalanceColumnId[] = ['debit', 'credit']

export const EXPERT_TRIAL_BALANCE_COLUMN_LABEL_KEYS: Record<ExpertTrialBalanceColumnId, string> = {
  accountNumber: 'expert_trial_balance.table.column.account_number',
  balance: 'expert_trial_balance.table.column.balance',
  balancePrevious: 'expert_trial_balance.table.column.balance_previous',
  credit: 'expert_trial_balance.table.column.credit',
  debit: 'expert_trial_balance.table.column.debit',
  label: 'expert_trial_balance.table.column.label',
}

const EXPERT_TRIAL_BALANCE_COLUMN_ID_SET = new Set<string>(EXPERT_TRIAL_BALANCE_COLUMN_IDS)

export const isExpertTrialBalanceColumnId = (value: string): value is ExpertTrialBalanceColumnId =>
  EXPERT_TRIAL_BALANCE_COLUMN_ID_SET.has(value)

export const parseHiddenColumnIds = (value: unknown): ExpertTrialBalanceColumnId[] => {
  if (!Array.isArray(value)) {
    return EXPERT_TRIAL_BALANCE_DEFAULT_HIDDEN_COLUMN_IDS
  }

  const hiddenColumnIds = value.filter(
    (id): id is ExpertTrialBalanceColumnId => typeof id === 'string' && isExpertTrialBalanceColumnId(id),
  )
  const hiddenColumnIdSet = new Set(hiddenColumnIds)

  if (EXPERT_TRIAL_BALANCE_COLUMN_IDS.every((id) => hiddenColumnIdSet.has(id))) {
    return EXPERT_TRIAL_BALANCE_DEFAULT_HIDDEN_COLUMN_IDS
  }

  return hiddenColumnIds
}
